const result = {};

export default result;
